module.exports = __webpack_public_path__ + "img/success.cd529074.png";